module.exports = __webpack_public_path__ + "media/images/faqs/bg-1bcbcac69408d60b1aeea46664529855.png";